import React, { Component } from 'react';
import Button from 'components/UI/Button';
import Box from 'components/UI/Box';
import { Link } from 'react-router-dom';
import CollapsableRow from 'components/CollapsableRow';
import { toast } from 'react-toastify';
import axios from 'axios';
import Select from 'react-select';
import { API_URL, ERROR_HANDLE, DOWNLOAD } from 'config/constants';

const labels = ['Gym', 'Email', 'Rate/min', 'Flat rate', 'Action'];

const style = {
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px"
    },
    gymSelector: {
        container: (base, state) => ({
            ...base,
            minWidth: "200px",
            maxWidth: "400px",
            margin: "0px 10px"
        }),
        control: (base, state) => {
            return {
                ...base,
                border: "1px solid #444445",
                borderRadius: "36px"
                // height: "40px"
            };
        }
    },
    titleWrapper: {
        display: 'flex'
    },
    titleItem: {
        flex: '1',
        fontSize: '20px',
        color: '#00b4d2'
    },
    box: {
        width: '900px',
        alignItems: 'center'
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px',
        flexDirection: 'column',
        alignItems: 'center'
    },
    input: {
        border: "1px solid #444445",
        borderRadius: "50px",
        width: "100px",
        fontSize: "22px",
        color: "#00b4d2",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "5px",
        paddingBottom: "5px"
    },
    notifyButton: {
        marginLeft: "20px",
        width: 100,
        fontSize: "18px",
        height: '40px'
    },
};



class FlatRates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gymsWithRateSet: [],
            gyms: [],
            qty: ''
        };
    };

    componentDidMount() {
        this.getGyms();
        this.getAllGyms();
    }

    gymRows = gyms =>
        gyms.map((currentItem, i) => {
            const gymId = currentItem.id;
            const style = {
                itemWrapper: {
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center'
                },
                item: {
                    flex: '1',
                },
                button: {
                    width: '77px',
                    height: '29px',
                    fontSize: '16px',
                    color: '#414141'
                },
                collapsableWrapper: {
                    backgroundColor: '#000',
                    color: '#b5b5b6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 0px'
                },
                collapseLabel: {
                    fontSize: '10px'
                },
                collapseItem: {
                    margin: '0px'
                }
            };
            let persistent = (
                <div>
                    <hr style={{ borderTop: '1px solid #b5b5b6', borderRadius: '0.5px' }} />

                    <div style={style.itemWrapper}>
                        <p style={{ ...style.item }}>{currentItem.gym_name}</p>
                        <p style={{ ...style.item }}>{currentItem.email}</p>
                        <p style={{ ...style.item }}>&#36;{currentItem.rate}</p>
                        <p style={{ ...style.item }}>&#36;{currentItem.flat_rate}</p>
                        <Button
                            style={{ ...style.item, ...style.button }}
                            onClick={() => this.deleteRateForGym(gymId)}>
                            Delete
                    </Button>
                    </div>
                </div>
            );

            return { persistent: persistent };
        });

    deleteRateForGym(gymId) {
        const access_token = localStorage.getItem('access_token');
        const toastId = toast("Deleting rate for gym...");
        axios
            .post(
                `${API_URL}/admin/delete-flat-rate`,
                {
                    gymId
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    gymsWithRateSet: this.state.gymsWithRateSet.filter(gym => gym.id !== gymId)
                })
            })
            .catch(err => {
                toast.dismiss(toastId);
                setTimeout(() => {
                    ERROR_HANDLE(err);
                }, 500);
            });
    }

    getGyms() {
        const access_token = localStorage.getItem('access_token');
        axios
            .get(`${API_URL}/admin/flat-rates`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                this.setState({
                    gymsWithRateSet: res.data.gyms,
                });
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    getAllGyms() {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Fetching Gyms List...");
        axios
            .get(`${API_URL}/admin/gymIds`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    ...this.state,
                    allgyms: res.data.map(gym => ({ value: gym.id, label: gym.name }))
                });
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    header = () => <div style={style.titleWrapper}>{labels.map((label, i) => {
        return (
            <p style={style.titleItem} key={i}>
                {label}
            </p>
        );
    })}</div>;

    selectGyms = selectedItems => {
        let filterGyms = selectedItems.map(gym => gym.value);
        this.setState({
            gyms: filterGyms
        });
    };

    clearAllFlatRates = () => {
        const gymIds = this.state.gymsWithRateSet.map(gym => gym.id);
        const access_token = localStorage.getItem('access_token');
        const toastId = toast("Clearing rates...");
        axios
            .post(
                `${API_URL}/admin/delete-flat-rate`,
                {
                    gymId: gymIds
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(() => {
                toast.dismiss(toastId);
                this.setState({
                    gymsWithRateSet: []
                })
            })
    }

    setFlatRates = () => {

        const { qty, gyms } = this.state;
        console.log(qty, Number.isNaN(Number(qty)))
        if (!gyms.length) {
            toast.error("Select some gyms", { autoClose: 1500 });
            return
        }
        else if (!qty || Number.isNaN(Number(qty))) {
            toast.error("Valid rate is needed", { autoClose: 1500 });
            return
        }
        else {
            const toastId = toast("Setting rate for gyms...");
            const access_token = localStorage.getItem("access_token");
            axios
                .post(
                    `${API_URL}/admin/flat-rates`,
                    {
                        flatRate: qty,
                        gyms: gyms
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": access_token
                        }
                    }
                )
                .then(res => {
                    toast.dismiss(toastId);
                    toast("Success", { autoClose: 1500 });
                    this.setState({
                        qty: '',
                        gyms: []
                    })
                    this.getGyms();
                })
                .catch(err => {
                    toast.dismiss(toastId);
                    setTimeout(() => {
                        ERROR_HANDLE(err);
                    }, 500);
                });
        }
    }

    render() {
        return (
            <div style={style.wrapper}>
                <Box style={{ ...style.box, display: 'flex' }} outline>
                    <p style={style.selectorLabel}>
                        Gyms &nbsp;
                    </p>
                    <Select
                        styles={{ ...style.gymSelector }}
                        options={this.state.allgyms}
                        isMulti={true}
                        onChange={this.selectGyms}
                    />
                    <p style={style.selectorLabel}>
                        &nbsp; &nbsp; &#36; &nbsp;
                    </p>
                    <input
                        type="text"
                        style={style.input}
                        name="qty"
                        value={this.state.qty}
                        onChange={e => {
                            this.setState({
                                ...this.state,
                                [e.target.name]: e.target.value
                            });
                        }}
                    />
                    <Button
                        style={style.notifyButton}
                        type="holo"
                        holo
                        onClick={this.setFlatRates.bind(this)}
                    >
                        Set Rate
                    </Button>
                    <Button
                        style={style.notifyButton}
                        type="holo"
                        holo
                        onClick={this.clearAllFlatRates.bind(this)}
                    >
                        Clear All
                    </Button>
                </Box>
                <Box style={{ ...style.box, marginTop: 10 }} outline>
                    {this.header()}
                    {this.gymRows(this.state.gymsWithRateSet).map((currentItem, i) => (
                        <CollapsableRow data={currentItem} key={i} />
                    ))}
                </Box>
            </div>
        );
    }
}

export default FlatRates;
